import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Percent from '../../../../../frontend/components/components/utils/numbers/Percent';
import './TendenceTable.scss'

const TendenceTable = ({
  data,
  limit = 10,
  showIndexes = true,
  showHeader = false,
  headerValues = []
}) => {
  const { t } = useTranslation();
  const orderedData = Object.keys(data || {})
    .map(key => data[key])
    .sort((a, b) => (b.percent * 100) - (a.percent * 100))
    .slice(0, limit);

  if (orderedData.length === 0) {
    return <Card className="empty my-4">
      {t('influencers.pages.analytics.not_enough_data')}
    </Card>;
  }

  return (
    <Table striped bordered hover>
      {
        showHeader &&
        <thead className='tendence-header'>
          <tr>
            {
              showIndexes &&
              <td>
              </td>
            }
            {
              Object.keys(headerValues).map((titleKey) => (
                <td key={titleKey}>
                  {headerValues[titleKey]}
                </td>
              ))
            }
          </tr>
        </thead>
      }
      <tbody>
        {
          orderedData.map((hashtag, i) => (
            <tr key={hashtag.name}>
              {
                showIndexes &&
                <td>
                  {i + 1}
                </td>
              }
              <td>
                {hashtag.name}
              </td>
              <td>
                <Percent number={hashtag.percent} />
              </td>
            </tr>
          ))
        }
      </tbody>
    </Table>
  );
};

export default React.memo(TendenceTable);
